/**
 * Dates and times in the Listings Manager.
 *
 * Every timestamp in this system is stored in UTC, and this project's
 * standing rule is that it is READ in Europe/London. An enquiry that came
 * in at 00:20 on a summer evening is a Tuesday enquiry to the agent, and a
 * screen that renders it as Wednesday 23:20 is telling them the wrong day
 * about the wrong call.
 *
 * The zone comes from productBrand, so the US product renders its own:
 * it is not hard-coded here even though today only one market uses this
 * screen.
 *
 * Named `agencyDate` rather than `fmtDate` on purpose. CrmLayout already
 * exports a `fmtDate`, and it formats in the BROWSER's zone rather than
 * the agency's — the same answer for a UK agent sitting in the UK, and a
 * different one for anybody else. Two functions that disagree must not
 * share a name; a test catches the collision, and the name says which
 * clock this one reads.
 */
import { productBrand } from "@/lib/productBrand";

function parse(value) {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function agencyDateTime(value) {
  const d = parse(value);
  if (!d) return "";
  const { locale, tz } = productBrand();
  return d.toLocaleString(locale, {
    day: "numeric", month: "short", hour: "2-digit", minute: "2-digit",
    timeZone: tz,
  });
}

export function agencyDate(value) {
  const d = parse(value);
  if (!d) return "";
  const { locale, tz } = productBrand();
  return d.toLocaleDateString(locale, {
    day: "numeric", month: "short", year: "numeric", timeZone: tz,
  });
}
